import { render, staticRenderFns } from "./BaseSupplierDialogSelector.vue?vue&type=template&id=40f15260"
import script from "./BaseSupplierDialogSelector.vue?vue&type=script&lang=js"
export * from "./BaseSupplierDialogSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports